import Contact from '@api/Contact'
import {
    IRequestFindContact,
    IResponseFindContact,
    IResponseFindContactRowData,
} from '@apiinterface/IContact'
import {
    IRequestGetAllQuizs,
    IResponseGetAllQuizs,
    IResponseGetAllQuizsRowData,
} from '@apiinterface/IQuiz'
import DownloadExcel from '@components/button/DownloadExcel'
import ChartSection from '@components/chart/ChartSection'
import ConcludeBoxData from '@components/chart/ConcludeBoxData'
import PieChartContact from '@components/chart/PieChartContact'
import PieChart from '@components/chart/PieChart'
import InputDate from '@components/inputs/InputDate'
import PageLayout from '@components/page/PageLayout'
import api from '@config/api'
import { Button, Flex, LoadingOverlay, Paper, Title } from '@mantine/core'
import { isNotEmpty, useForm } from '@mantine/form'
import NumberAmount from '@utils/NumberAmount'
import React, { useContext, useEffect, useState } from 'react'
import { AuthContext } from '@context/AuthContext'

const AdminDashBoard = () => {
    const [data, setData] = useState<IResponseGetAllQuizsRowData[]>([])
    const [contactData, setContactData] = useState<
        IResponseFindContactRowData[]
    >([])
    const { checkRole } = useContext(AuthContext)
    const [normalPeople, setNormalPeople] = useState(0)
    const [employPeople, setEmployPeople] = useState(0)
    const [Loading, setLoading] = useState<boolean>(false)
    const [isEmpty, setIsEmpty] = useState<boolean>(false)
    const form = useForm({
        initialValues: {
            created_at: '',
            created_at_end: '',
        },
        validate: {
            created_at: isNotEmpty('กรุณากรอกข้อมูล'),
        },
    })
    useEffect(() => {
        setNormalPeople(
            data.filter((e) => e.person_type === 'บุคคลทั่วไป').length
        )
        setEmployPeople(data.filter((e) => e.person_type === 'พนักงาน').length)
    }, [data])

    useEffect(() => {
        console.log('contactData', contactData)
    }, [contactData])

    const loadBulkData = async (values: {
        created_at: string
        created_at_end: string
    }) => {
        try {
            setIsEmpty(false)
            setData([])
            setLoading(true)
            let page = 1
            let maxPage = 1
            let bulkData: IResponseGetAllQuizsRowData[] = []
            while (page <= maxPage) {
                const params: IRequestGetAllQuizs = {
                    created_at: values.created_at,
                    created_at_end: values.created_at_end,
                    limit: 100,
                    page: page,
                    search: '',
                    order: 'desc',
                    orderby: 'quiz_id',
                }

                const loaddata = await api.get('/quizs', { params })
                const body = loaddata.data.body as IResponseGetAllQuizs
                maxPage = body.totalPages
                bulkData = [...bulkData, ...body.lists]
                page += 1

                await new Promise((resolve) => setTimeout(resolve, 1000)) // Wait for 1 second
            }

            bulkData.forEach((element) => {
                if (
                    element.life_insurance_mtl === 'T' &&
                    element.life_insurance_other === 'T'
                ) {
                    element.life_insurance =
                        'มีประกันชีวิต mtl และประกันชีวิตอื่นๆ'
                } else if (
                    element.life_insurance_mtl === 'T' &&
                    element.life_insurance_other === 'F'
                ) {
                    element.life_insurance = 'มีประกันชีวิต mtl'
                } else if (
                    element.life_insurance_mtl === 'F' &&
                    element.life_insurance_other === 'T'
                ) {
                    element.life_insurance = 'มีประกันชีวิตอื่นๆ'
                }
            })

            setData(bulkData)
            setIsEmpty(bulkData.length ? false : true)
            setLoading(false)
        } catch (error) {
            console.log('Error=>', error)
        }

        try {
            //setIsEmpty(false)
            setContactData([])
            setLoading(true)
            let page = 1
            let maxPage = 1
            let bulkData: IResponseFindContactRowData[] = []
            while (page <= maxPage) {
                const params: IRequestFindContact = {
                    created_at: values.created_at,
                    created_at_end: values.created_at_end,
                    limit: 100,
                    page: page,
                    search: '',
                    order: 'desc',
                    orderby: 'quiz_id',
                }

                const loaddata = await api.get('/contact', { params })
                const body = loaddata.data.body as IResponseFindContact
                maxPage = body.totalPages
                bulkData = [...bulkData, ...body.lists]
                page += 1

                await new Promise((resolve) => setTimeout(resolve, 1000)) // Wait for 1 second
            }

            setContactData(bulkData)
            //setIsEmpty(bulkData.length ? false : true)
            setLoading(false)
        } catch (error) {
            console.log('Error=>', error)
        }
    }
    const findPercen = (value: number, max?: number) => {
        let percen = (value / (max || data.length)) * 100
        return percen.toFixed(2)
    }

    return (
        <PageLayout pageTitle='สรุปผลข้อมูลระบบ'>
            <form onSubmit={form.onSubmit((values) => loadBulkData(values))}>
                <LoadingOverlay visible={Loading} />
                <Flex gap='lg'>
                    <InputDate
                        label='ข้อมูลตั้งแต่วันที่'
                        w='100%'
                        {...form.getInputProps('created_at')}
                        placeholder='วันที่ที่ต้องการสรุปผลข้อมูล - ตั้งแต่'
                    />
                    <InputDate
                        label='ถึงวันที่'
                        w='100%'
                        {...form.getInputProps('created_at_end')}
                        placeholder='วันที่ที่ต้องการสรุปผลข้อมูล - ถึง'
                    />
                    <Button type='submit' mt='26px' color='fuchasia.4'>
                        ประมวลผล
                    </Button>
                    {Loading === false && data.length && checkRole([1, 2]) ? (
                        <DownloadExcel data={data} />
                    ) : (
                        ''
                    )}
                </Flex>
                {Loading === false && data.length ? (
                    <>
                        <Flex gap='lg' mt='md'>
                            <ConcludeBoxData
                                label='จำนวนผู้ตอบแบบประเมิน'
                                value={`${NumberAmount(data.length)}`}
                            />
                            <ConcludeBoxData
                                label='จำนวนพนักงาน'
                                value={`${employPeople} (${findPercen(
                                    employPeople
                                )}%)`}
                            />
                            <ConcludeBoxData
                                label='จำนวนบุคคลทั่วไป'
                                value={`${normalPeople} (${findPercen(
                                    normalPeople
                                )}%)`}
                            />
                        </Flex>
                        <Flex direction='column' mt='md'>
                            <Title order={4}>
                                จำนวนผู้ตอบแบบประเมินแบ่งตามประเภทบุคคล
                            </Title>
                            <PieChart data={data} keyData='person_type' />
                        </Flex>

                        <Flex direction={'row'}>
                            <Flex direction='column' mt='md'>
                                <Title order={4}>
                                    จำนวนผู้ตอบแบบประเมินเรื่องประกันชีวิต /
                                    พนักงาน
                                </Title>
                                <PieChart
                                    data={data.filter(
                                        (d) => d.person_type === 'พนักงาน'
                                    )}
                                    keyData='life_insurance'
                                />
                            </Flex>

                            <Flex direction='column' mt='md'>
                                <Title order={4}>
                                    จำนวนผู้ตอบแบบประเมินเรื่องประกันชีวิต /
                                    บุคคลทั่วไป
                                </Title>
                                <PieChart
                                    data={data.filter(
                                        (d) => d.person_type === 'บุคคลทั่วไป'
                                    )}
                                    keyData='life_insurance'
                                />
                            </Flex>
                        </Flex>
                        <Flex gap='lg' mt='md'>
                            <ConcludeBoxData
                                label='จำนวนรวมผู้เข้าขอรับคำปรึกษา'
                                value={`${contactData.length}`}
                            />

                            <ConcludeBoxData
                                label='จำนวนผู้ขอรับคำปรึกษา : เปิดเผยข้อมูล'
                                value={`${contactData.filter((d) => d.disclosing === 'T').length} (${findPercen(
                                    contactData.filter(
                                        (d) => d.disclosing === 'T'
                                    ).length,
                                    contactData.filter((d) => d.disclosing)
                                        .length
                                )}%)`}
                            />

                            <ConcludeBoxData
                                label='จำนวนผู้ขอรับคำปรึกษา : ไม่เปิดเผยข้อมูล'
                                value={`${contactData.filter((d) => d.disclosing === 'F').length} (${findPercen(
                                    contactData.filter(
                                        (d) => d.disclosing === 'F'
                                    ).length,
                                    contactData.filter((d) => d.disclosing)
                                        .length
                                )}%)`}
                            />
                        </Flex>
                        <Flex direction={'row'}>
                            <Flex direction='column' mt='md'>
                                <Title order={4}>เรื่องที่ขอรับคำปรึกษา</Title>
                                <PieChartContact
                                    data={contactData}
                                    keyData='topic'
                                />
                            </Flex>
                        </Flex>

                        <Flex direction='column' mt='md'>
                            <Title order={4}>
                                เป้าหมายชีวิตและเป้าหมายทางการเงินของคุณวันนี้คือ
                                ?
                            </Title>
                            <ChartSection data={data} keyData='question_1' />
                        </Flex>

                        <Flex direction='row' mt='md'>
                            <Flex direction='column' mt='md' w={'33%'}>
                                <Title order={4}>
                                    คุณคิดว่าเงินออมต่อเดือน
                                    ควรเป็นกี่เปอร์เซ็นของรายได้
                                </Title>
                                <PieChart data={data} keyData='question_2' />
                            </Flex>
                            <Flex direction='column' mt='md' w={'33%'}>
                                <Title order={4}>
                                    คุณมีแนวความคิดอย่างไรในเรื่องของการวางแผนเกษียณ
                                </Title>
                                <PieChart data={data} keyData='question_3' />
                            </Flex>
                            <Flex direction='column' mt='md' w={'33%'}>
                                <Title order={4}>
                                    คุณเคยคำนวณเงินเพื่อการเกษียณแล้วหรือยัง
                                </Title>
                                <PieChart data={data} keyData='question_4' />
                            </Flex>
                        </Flex>
                    </>
                ) : (
                    <Paper ta='center' p='lg'>
                        {isEmpty ? 'ไม่พบข้อมูล' : ''}
                    </Paper>
                )}
            </form>
        </PageLayout>
    )
}

export default AdminDashBoard
